import { getHrPendings } from "api/Pendings";
import { useQuery } from "react-query";

export const useHrPendings = () => {
    const { data, isLoading } = useQuery<Array<any> | any>(["hrPendings"],
        () => {
            return getHrPendings();
        },
    );

    return {
        data,
        isLoading,
    };
};

